<template>
  <v-layout row justify-center>
    <v-dialog v-if="userData" persistent v-model="dialog" max-width="700">
      <v-card>
        <v-card-title>
          <span class="headline mr-4 d-flex">
            <v-img
              class="d-inline-block mr-2"
              :src="discountIcon"
              width="24px"
              contain
            ></v-img>
            <span>Set Discount for user: {{ userData.email }}</span>
          </span>
          <v-btn absolute left depressed flat fab small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-form ref="set_discount" data-vv-scope="set_discount" lazy-validation>
            <v-layout v-if="loading" row justify-center py-5 >
              <v-progress-circular
                :size="150"
                :width="7"
                color="blue"
                indeterminate
              ></v-progress-circular>
            </v-layout>
            <v-layout v-else row wrap pb-3>
              <v-flex xs4 style="margin: auto;">
                User Discount*:
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  label="Persents"
                  v-model="form.percentage"
                  v-validate="'required|decimal'"
                  data-vv-name="set_discount.percentage"
                  :error-messages="errors.collect('set_discount.percentage')"
                  required
                  height="32"
                >
                  <template v-slot:append>
                    %
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs4 style="margin: auto;">
                From Date*:
              </v-flex>
              <v-flex xs8>
                <v-menu
                  :close-on-content-click="false"
                  v-model="fromDateMenu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="fromDateFormatted"
                    prepend-icon="event"
                    readonly
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                  <v-date-picker
                    v-model="form.from_date"
                    :first-day-of-week="$store.state.user.first_day_of_week"
                    @input="fromDateMenu = false"
                    min="1990-01-01"
                    :max="form.to_date"
                    required
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs4 style="margin: auto;">
                To Date*:
              </v-flex>
              <v-flex xs8>
                <v-menu
                  :close-on-content-click="false"
                  v-model="toDateMenu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="toDateFormatted"
                    prepend-icon="event"
                    readonly
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                  <v-date-picker
                    v-model="form.to_date"
                    :first-day-of-week="$store.state.user.first_day_of_week"
                    @input="toDateMenu = false"
                    :min="form.from_date"
                    required
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs4 pt-4 style="margin: auto;">
                Disable after single use*:
              </v-flex>
              <v-flex xs8 pt-4>
                <v-checkbox
                  v-model="form.one_off"
                  class="mt-0 pt-0"
                  label="Discount single activation"
                  hide-details
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="saveChanges()" :loading="loading" :disabled="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'SetDiscountModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['setDiscountDialog', 'userData', 'discount'],
  data () {
    return {
      dialog: this.setDiscountDialog,
      discountIcon: require('@/assets/img/brightness_percent_grey.png'),
      loading: false,
      form: {
        id: this.discount ? this.discount.id : null,
        percentage: this.discount ? this.discount.percentage : 0,
        from_date: this.discount ? this.discount.from_date : this.$moment().format('YYYY-MM-DD'),
        to_date: this.discount ? this.discount.to_date : this.$moment().add(1, 'month').format('YYYY-MM-DD'),
        one_off: this.discount ? this.discount.one_off : false,
        user_id: this.userData.id
      },
      fromDateMenu: false,
      toDateMenu: false,
      rules: {
        required: value => (!!value || value === 0) || 'Required.'
      },
      dictionary: {
        en: {
          custom: {
            'set_discount.percentage': {
              required: 'Discount percentage required',
              decimal: 'Only number'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
    // this.getUserDiscount()
  },
  watch: {
    setDiscountDialog: {
      handler () {
        this.dialog = this.setDiscountDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('setDiscountDialog', this.dialog)
      }
    }
  },
  computed: {
    fromDateFormatted () {
      return this.$moment(this.form.from_date).format('DD-MM-YYYY')
    },
    toDateFormatted () {
      return this.$moment(this.form.to_date).format('DD-MM-YYYY')
    }
  },
  methods: {
    // getUserDiscount () {
    //   this.loading = true
    //   let params = {
    //     page: 1,
    //     count: 25,
    //     order_by: 'id',
    //     direction: 'asc',
    //     filter_blocks: [{ operator: 'and', filters: [{ column: 'user_id', operator: '=', value: this.userData.id }] }]
    //   }
    //   this.$store.dispatch('GET_DISCOUNTS', params).then(res => {
    //     if (res.data.length) {
    //       this.form = res.data[0]
    //     }
    //     this.loading = false
    //   }, err => {
    //     console.log('GET_DISCOUNTS ERROR', err)
    //     this.loading = false
    //     this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${this.$services.getApiError(err)}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
    //   })
    // },
    saveChanges () {
      this.$validator.validateAll('set_discount').then(res => {
        if (res) {
          this.loading = true
          if (this.form.id) {
            this.$store.dispatch('EDIT_DISCOUNT', { discountId: this.form.id, discount: this.form }).then(res => {
              this.loading = false
              this.$toasted.show('User discount was successfully edited')
              this.$parent.$emit('updateDiscountsList')
              this.closeModal()
            }, err => {
              console.log('EDIT_DISCOUNT error', err)
              this.loading = false
              this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${this.$services.getApiError(err)}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
            })
          } else {
            this.$store.dispatch('CREATE_DISCOUNT', this.form).then(res => {
              this.loading = false
              this.$toasted.show('User discount was successfully created')
              this.$parent.$emit('updateDiscountsList')
              this.closeModal()
            }, err => {
              console.log('CREATE_DISCOUNT error', err)
              this.loading = false
              this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${this.$services.getApiError(err)}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
            })
          }
        }
      })
    },
    closeModal () {
      this.dialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/SetDiscountModal.vue